import type { OptionValueDto } from "@models/option";

// An option value is soft-deleted (AC-10), and GET /options still lists a
// deleted value, flagged inactive. Only the active ones may be shown.
export const activeOptionValues = (values: OptionValueDto[]): OptionValueDto[] =>
    values.filter((value) => value.isActive);
